<template>
    <div style="background: none; padding: 9px;">




<!-- <v-badge color="red" left>
        <template v-slot:badge>
          <span> {{count_not_read}} </span>
        </template>

        <img src="https://onemail-chat.korkla.in/backend/api/v1/getFile/4379aa7a-4c58-4c8c-8c93-2083e9801f04/app_logo.png" style="max-height: 50px; max-width: 50px; border-radius: 10px;cursor: pointer;"/>
      </v-badge> -->



<v-badge color="red" >
        <template v-slot:badge v-if="count_not_read!=0">
          <span> {{count_not_read}} </span>
        </template>
         <img src="https://onemail-chat.korkla.in/backend/api/v1/getFile/4379aa7a-4c58-4c8c-8c93-2083e9801f04/app_logo.png" style="max-height: 50px; max-width: 50px; border-radius: 10px;cursor: pointer;"/>
      </v-badge>


     <!--  <v-badge color="red">
        <template v-slot:badge>
          <span>!</span>
        </template>
        <v-icon
          large
          color="grey"
        >
          mail
        </v-icon>
      </v-badge> -->



    </div>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Momenttime, Decode, Encode } from '@/services'

const get_detailuser = gql`
subscription ($user_id: uuid!) {
  list_chat(where: {user_id: {_eq: $user_id}}, order_by: {last_message_time: desc_nulls_last}) {
    count_not_read
  }
}
`

export default {
  data: () => ({
    user_id: '',
    count_not_read: 0
  }),
  apollo: {
    $subscribe: {
      list_chat: {
        query: get_detailuser,
        variables () {
          return {
            user_id: this.user_id
          }
        },
        result (data) {
          this.count_not_read = _.sumBy(data.data.list_chat, function(o) { return o.count_not_read; });
          // data.data.list_chat
          // console.log(this.list_chat)
        }
      }
    }
  },
  computed: {
    ...sync('*')
  },
  created () {
    this.getUserData()
  },
  methods: {
    getUserData() {
      var reqestBody = {onemail_token_encrypt: this.$route.query.onemail_token_encrypt, mail_encrypt: this.$route.query.mail_encrypt}

      this.axios.post(process.env.VUE_APP_API + '/getUserData', reqestBody).then((response) => {
        // console.log(response.data)
        if (response.status === 200) {
          // this.$session.set('auth_token', Encode.encodeToken(response.data.data.auth_token))
          // this.$session.set('onemail_token', Encode.encodeToken(response.data.data.onemail_token))
          this.user_id = response.data.data.user_id
          // localStorage.setItem('display_name', response.data.data.display_name)
          // localStorage.setItem('email', response.data.data.email)
        } else {
          console.error('not found')
        }
      }).catch((error) => {
        console.log(error.message)
      })
    }
  }
    
} 
</script>
<style type="text/css" scoped>
>>>.v-badge__badge {
  top: -7px !important;
    right: -10px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mail/minChat.vue